<template>
    <div class='tep-tv-table-wrap'>
        <table>
            <thead>
            <tr>
                <th></th>
                <th colspan='2'>Первичный контур</th>
                <th></th>
                <th colspan='2'>Вторичный контур</th>
                <th></th>
                <th colspan='2'>Температура наружного воздуха (°C)</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td></td>
                <td>Max под. T1</td>
                <td>Max обр. T2</td>
                <td></td>
                <td>Max под. T1</td>
                <td>Max обр. T2</td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td style='text-align: right'>Отопление</td>
                <td><ai-form-number-box-readonly :meta='{fieldNameText: "t1_so"}' :server-data='userData'></ai-form-number-box-readonly></td>
                <td><ai-form-number-box-readonly :meta='{fieldNameText: "t2_so"}' :server-data='userData'></ai-form-number-box-readonly></td>
                <td></td>
                <td><ai-form-number-box-readonly :meta='{fieldNameText: "t1_sovk"}' :server-data='userData'></ai-form-number-box-readonly></td>
                <td><ai-form-number-box-readonly :meta='{fieldNameText: "t2_sovk"}' :server-data='userData'></ai-form-number-box-readonly></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td style='text-align: right'>Вентиляция</td>
                <td><ai-form-number-box-readonly :meta='{fieldNameText: "t1_sw"}' :server-data='userData'></ai-form-number-box-readonly></td>
                <td><ai-form-number-box-readonly :meta='{fieldNameText: "t2_sw"}' :server-data='userData'></ai-form-number-box-readonly></td>
                <td></td>
                <td><ai-form-number-box-readonly :meta='{fieldNameText: "t1_swvk"}' :server-data='userData'></ai-form-number-box-readonly></td>
                <td><ai-form-number-box-readonly :meta='{fieldNameText: "t2_swvk"}' :server-data='userData'></ai-form-number-box-readonly></td>
                <td></td>
                <td style='text-align: right'>СО</td>
                <td>
                    <ai-form-select-box
                        :meta='selectBoxMeta'
                        :callbacks="{userDataChanged: changeSelect}"
                    ></ai-form-select-box>
                </td>
            </tr>
            <tr>
                <td style='text-align: right'>ГВС</td>
                <td><ai-form-number-box-readonly :meta='{fieldNameText: "t1_gwm"}' :server-data='userData'></ai-form-number-box-readonly></td>
                <td><ai-form-number-box-readonly :meta='{fieldNameText: "t2_gwm"}' :server-data='userData'></ai-form-number-box-readonly></td>
                <td></td>
                <td><ai-form-number-box-readonly :meta='{fieldNameText: "t1_gwsr"}' :server-data='userData'></ai-form-number-box-readonly></td>
                <td><ai-form-number-box-readonly :meta='{fieldNameText: "t2_gwsr"}' :server-data='userData'></ai-form-number-box-readonly></td>
                <td></td>
                <td style='text-align: right'>СВ</td>
                <td><ai-form-number-box-readonly :meta='{fieldNameText: "tnv_sw"}' :server-data='userData'></ai-form-number-box-readonly></td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: 'tep-tv-table-group',
};
</script>

<script setup>
import { inject } from 'vue';
import AiFormSelectBox from '@/components/card-component/ai-form-select-box.vue';
import AiFormNumberBoxReadonly from '@/components/card-component/ai-form-number-box-readonly.vue';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {}
    },
    serverData: {
        type: Object,
        default: () => {}
    },
    callbacks: {
        type: Object,
        default: () => ({ userDataChanged: null }),
    },
});

const userData = inject('userData');

const changeSelect = (() => {
    if(props.serverData[selectBoxMeta.fieldNameText] !== userData.value[selectBoxMeta.fieldNameText]) {
        if (props.callbacks.userDataChanged) props.callbacks.userDataChanged();
    }
})

const selectBoxMeta = {
    fieldNameId: 'tnv_so',
    fieldNameText: 'tnv_so',
    extParams: {
        displayExpr: 'tnv',
        valueExpr: 'tnv',
        dictionaryRoutePath: 'tep-grid./tep/lookup-tnv-values/get',
    },
};
</script>

<style scoped>
.tep-tv-table-wrap td {
    min-width: 20px;
    max-width: 100px;
    vertical-align: center;
    padding: 0 5px;
    box-sizing: border-box;
}
.tep-tv-table-wrap th {
    min-width: 20px;
    vertical-align: center;
    padding: 0 5px;
    box-sizing: border-box;
}

.tep-tv-table-wrap :deep(.dx-field-label) {
    min-height: 12px;
}
</style>
